import Counter from 'components/layouts/Counter';
import React from 'react';

const About = () => {
  document.title = 'About Us';
  return (
    <section className="mb-10">
      <div className="relative">
        <img
          src="/assets/images/about.jpg"
          alt="about"
          className="w-full object-cover brightness-75 lg:h-[620px] "
        />

        <div className="container absolute top-10 mx-auto h-[200px] px-5 md:h-[500px] lg:left-10">
          <div className="flex py-20">
            <div className="my-auto text-[40px] text-white">ABOUT US</div>
          </div>
        </div>
      </div>

      <br />
      <div className="container mx-auto px-5">
        <div className="mb-4 flex flex-col justify-between gap-3 lg:flex-row">
          <div className="flex flex-col gap-y-3 lg:basis-[75%]">
            <h3 className="text-[35px]">
              About <span className="text-red-400">Blockchain</span>{' '}
            </h3>
            <p className="leading-9 lg:text-xl">
              Blockchain is your leading cryptocurrency investment and trading
              platform that offers Binary and Forex trading options, provides
              24/7 customer support, high level of security, and stable deposits
              and withdrawals. Our focus is to provide our investors with daily
              and constant profits in these markets. Our mission is to act as a
              catalyst for universal adoption and blockchain innovation. We
              focus only on investing in blockchain technologies. Our team has
              experience in both traditional financing and emerging blockchain
              technology.
            </p>
          </div>
          <div className="lg:basis-[25%]">
            <img
              src="/assets/images/info.jpg"
              alt="about"
              className="h-full w-full rounded-md lg:h-[290px] lg:w-[600px]"
            />
          </div>
        </div>
        <br />
        <div className="text-center">
          <h3 className="text-[40px]">We take care of our quality</h3>
          <p className="text-lg">
            We always provide our best quality for users
          </p>
        </div>
        <div className="mt-[60px] flex flex-col flex-wrap justify-center gap-y-4 md:flex-row">
          <div className="basis-1/3 cursor-pointer rounded-lg bg-slate-100 py-14 px-5 text-center hover:bg-slate-100 md:basis-1/2 md:bg-inherit lg:basis-1/3">
            <img
              src="/assets/icons/award.svg"
              alt="icon"
              className="mx-auto mb-5 h-[50px] w-[50px]"
            />
            <p className="my-3 text-xl font-semibold">Best trading platform</p>
            <p className="mx-auto w-[80%]">
              Chance to magnify your investment and really win big with
              super-low spreads to further up your profits.
            </p>
          </div>
          <div className="basis-1/3 cursor-pointer rounded-lg bg-slate-100 py-14 px-5 text-center hover:bg-slate-100 md:basis-1/2 md:bg-inherit lg:basis-1/3">
            <img
              src="/assets/icons/globe.svg"
              alt="icon"
              className="mx-auto mb-5 h-[50px] w-[50px]"
            />
            <p className="my-3 text-xl font-semibold">Comfortable ecosystem</p>
            <p className="mx-auto w-[80%]">
              Blockchain offers multiple platform options to cover the needs of
              each type of trader and investors
            </p>
          </div>
          <div className="basis-1/3 cursor-pointer rounded-lg bg-slate-100 py-14 px-5 text-center hover:bg-slate-100 md:basis-full md:bg-inherit lg:basis-1/3">
            <img
              src="/assets/icons/lock.svg"
              alt="icon"
              className="mx-auto mb-5 h-[50px] w-[50px]"
            />
            <p className="my-3 text-xl font-semibold">Trusted security</p>
            <p className="mx-auto w-[80%]">
              Blockchain is secured by 256 bits SSL security encryption to
              ensure that your information is completely protected from fraud.
            </p>
          </div>
        </div>
        <div className="my-5 flex flex-col flex-wrap gap-x-8 gap-y-3 md:flex-row">
          <div className="basis-[45%] py-5">
            <h3 className="my-2 text-center text-2xl font-bold text-blue-500">
              Mission
            </h3>
            <p>
              The philosophy behind Tradefxmine is in essence very simple: An
              investor who understands their investments will see this reflected
              in their returns. Tradefxmine meets hundreds of investors every
              year during seminars, open days, social drinks, sporting events
              and other (investor) meetings. Through these we educate our
              clients and guide them along their investment path.
            </p>
          </div>

          <div className="basis-[45%] py-5">
            <h3 className="my-2 text-center text-2xl font-bold text-blue-500">
              What we do
            </h3>
            <p>
              We operate through corporate accounts that allow us to manage the
              capital of different parts of the world with absolute security and
              transparency, giving each user the opportunity to access trading
              programs, supported by cutting-edge technologies without prior
              knowledge or experience. We use software called Expert Advisors
              (EAs), specially designed for Blockchain, with algorithms that
              allow you to analyze different types of scenarios in the currency
              markets, obtaining successful results.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-slate-100 py-20">
        <div className="mx-auto p-5 lg:w-[50%]">
          <div className="flex flex-col items-center justify-between gap-y-10 gap-x-5 md:flex-row">
            <div className="w-full">
              <p className="text-2xl font-bold text-gray-700">Number speaks</p>
              <br />
              <p className="text-[40px] font-bold">
                We are always <span className="text-red-500">ready</span>
              </p>
              <p className="text-[40px] font-bold">for a challenge.</p>
            </div>
            <div className="w-full">
              <div className="flex gap-x-5">
                <div className="flex border-b pb-4 text-2xl text-blue-500">
                  <Counter from={20} to={500} />+
                </div>
                <p className="text-2xl font-bold">Active investors</p>
              </div>
              <br />
              <div className="mt-5 flex gap-x-5">
                <div className="flex text-2xl text-blue-500">
                  <Counter from={1} to={25} />
                  M+
                </div>
                <p className="text-2xl font-bold">Profit raised</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
